import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.application_progress.title',
        defaultMessage: `Thanks! We're reviewing your application and will get back to you as soon as possible`
    },
    description: {
        id: '_.application_progress.description',
        defaultMessage: `We’ll aim to email you with a decision within 24 hours. If
        you have any questions about your application don’t hesitate
        to call us on {phoneNumber}`
    },
    phoneNumber: {
        id: '_.application_progress.phone_number',
        defaultMessage: '020 3778 0105'
    },
    loadingHeader: {
        id: '_.loading_application.header',
        defaultMessage: 'We’re completing your application'
    },
    loadingDescription: {
        id: '_.loading_application.description',
        defaultMessage: 'This may take up to 60 seconds'
    }
});
